import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {},
	extraButton: {
		width: 'max-content',
		height: 40.26
	}
}));